module.exports = __webpack_public_path__ + "img/linkou.b17a991f.png";